module.exports = __webpack_public_path__ + "static/IPC-ba4e4cb0ff62f119a111ca7ec267e90b.png";